module.exports = __webpack_public_path__ + "static/media/haze.97850978.jpeg";